import React from "react";
import * as S from "./styles";

var ProgressBarStep = function ProgressBarStep(_ref) {
  var e = _ref.accomplished,
      a = _ref.index,
      t = _ref.label,
      l = _ref.currentStep,
      c = _ref.goToStep,
      s = _ref.isDisabled,
      r = _ref.hasTopLabels;
  var n = e && a < l ? {
    onClick: function onClick(e) {
      return !s && c(a);
    }
  } : {},
      o = l === a;
  return React.createElement(React.Fragment, null, React.createElement(S.StepCircle, Object.assign({
    className: "" + (e ? "accomplished" : null),
    disabled: s
  }, n), o ? a + 1 : e ? React.createElement(S.Checkmark, null) : a + 1), React.createElement(S.StepLabel, Object.assign({
    className: "" + (e ? "accomplished" : null),
    active: o,
    disabled: s,
    hasTopLabels: r
  }, n), t));
};

export default ProgressBarStep;